import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, signal} from '@angular/core';
import {OphIconModule} from 'src/app/shared/design/oph-icon/oph-icon.module';
import {CbOutlineComponent} from '../../cb-outline/cb-outline.component';
import {CHALLENGE_BUILDER_STEP_MAP, ChallengeBuilderSteps} from '../../challenge-builder-data';
import {ChallengeBuilderProject} from 'src/app/core/model/project';
import {MatTooltipModule} from '@angular/material/tooltip';

type TabOption = 'tips' | 'outline';

@Component({
  selector: 'cb-sidebar',
  standalone: true,
  imports: [CommonModule, OphIconModule, CbOutlineComponent, MatTooltipModule],
  templateUrl: './cb-sidebar.component.html',
  styleUrl: './cb-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbSidebarComponent {
  @Input() currentStep: ChallengeBuilderSteps | 'overview' = ChallengeBuilderSteps.GOAL;
  @Input() cbProject: ChallengeBuilderProject | null = null;

  selectedTab = signal<TabOption>('tips');

  readonly stepMap = CHALLENGE_BUILDER_STEP_MAP;

  selectTab(tab: TabOption): void {
    this.selectedTab.set(tab);
  }
}
